import { Avatar, Stack } from '@mui/material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import React from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';

const NearestTurnContent = ({ doctorList }) => {
  return (
    <React.Fragment>
      <Stack alignItems="center" justifyContent="center">
        {doctorList?.doctor?.imageArrayContent?.image ? (
          <img
            src={`data:image/png;base64,${doctorList?.doctor?.imageArrayContent?.image}`}
            loading="..."
            width={70}
            height={70}
            style={{ borderRadius: '100%' }}
          />
        ) : (
          <Avatar
            sx={{
              fontSize: '2.5em',
              color: themeColors.ColorSecondary,
              backgroundColor: themeColors.ColorPrimary,
            }}
          />
        )}
      </Stack>
      <p style={{ textAlign: 'center', marginTop: '1em' }}>
        {ArabicToPersian(doctorList?.doctor?.nameDoctor)}
          
        {ArabicToPersian(doctorList?.doctor?.familyDoctor)}
      </p>
      <Stack
        sx={{ mt: '1em' }}
        justifyContent="space-between"
        alignItems="center"
        gap=".5em"
      >
        <p>
          {ArabicToPersian(
            doctorList?.dayInfo?.NameService
          )}
        </p>
        <Stack direction="row-reverse" gap="1em">
          <p>
            {ArabicToPersian(doctorList?.dayInfo?.dayName)}
          </p>
          <p>{doctorList?.dayInfo?.Text}</p>
          <p>{doctorList?.dayInfo?.timeDuration}</p>
        </Stack>
      </Stack>
      {/* {doctorList?.NazdickTarinNobat?.dayInfo
      ?.daryafteNobateBaHazine &&
    doctorList?.NazdickTarinNobat?.dayInfo
      ?.hazineDaryafteNobat ? (
      <Stack
        direction="row-reverse"
        mt="1em"
        alignItems="center"
        justifyContent={'center'}
        gap="1em"
        border={`1px solid ${themeColors.ColorPrimary}`}
        py={'.2em'}
        borderRadius={'.3em'}
      >
        <p>{label_price}</p>
        <p
          style={{
            color: `${themeColors.ColorPrimary}`,
            textAlign: 'center',
          }}
        >
          {Price3DigitSplitter(
            Number(
              doctorList?.NazdickTarinNobat?.dayInfo
                ?.hazineDaryafteNobat
            )
          )}
             ریال
        </p>
      </Stack>
    ) : (
      <></>
    )} */}
    </React.Fragment>
  );
};

export default NearestTurnContent;
